import { type ReactNode, useRef } from 'react';
import type { AuditAction } from '@core/enum/auditAction';
import type { AuditLogRenderer } from '@core/utils/auditLog';
import { registerAuditLogRenderers } from './renderers';

interface AuditLogProviderProps {
  renderers: Partial<Record<AuditAction, AuditLogRenderer>>;
  children: ReactNode;
}

const AuditLogProvider = ({ renderers, children }: AuditLogProviderProps) => {
  const registered = useRef(false);

  if (!registered.current) {
    registerAuditLogRenderers(renderers);
    registered.current = true;
  }

  return children;
};

export default AuditLogProvider;
